import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "react-multi-carousel/lib/styles.css";
import "tailwindcss/tailwind.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
// import { GlobalStyles } from "twin.macro";

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<Router basename="/">
				{/* <GlobalStyles /> */}
				<App />
			</Router>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
